module.exports = __webpack_public_path__ + "static/img/jigou-dalian-top.f9a2fe8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jigou/jigou-dalian-top.png
// module id = RWR7
// module chunks = 2